import type z from 'zod'

import { schemas } from '~interface/zod-schema'

export const PermissionState = {
  POLICY_BLOCKED: 'policy-blocked',
  BROWSER_DENIED: 'browser-denied',
  BROWSER_GRANTED: 'browser-granted',
  BROWSER_PROMPT: 'browser-prompt',
  UNKNOWN: 'unknown',
  LOADING: 'loading',
} as const
export type PermissionState = (typeof PermissionState)[keyof typeof PermissionState]

export const GeneralResourceEnum = schemas.GeneralResourceEnum
export const AccessActionEnum = schemas.AccessActionEnum
export type GeneralResource = z.infer<typeof GeneralResourceEnum>
export type AccessAction = z.infer<typeof AccessActionEnum>
export type RolePolicyTuple = z.infer<typeof schemas.RolePolicyTuple>
export type ExternalRoleAssignment = z.infer<typeof schemas.ExternalRoleAssignment>
export type InboundExternalRole = z.infer<typeof schemas.InboundExternalRole>
